/**
 * @prettier
 * @flow
 */
import { environment } from 'src/config/environment';
import { Environment } from 'src/constants/Environment';

let cryptoKeys = {};
if (environment === Environment.PROD) {
    cryptoKeys = {
        ENCRYPTION_DATA_IN_TRANSIT_PUBLIC_KEY: 'MFwwDQYJKoZIhvcNAQEBBQADSwAwSAJBAKuYcsRuLJF+4pK0p1HXqJAni//6xTuOUtWwtbyxqmaXb8/gqL3UGqI49PB8KsOWJbDFp+vq3qE/Do+vQKQPrTcCAwEAAQ==',
    };
} else if (environment === Environment.TEST) {
    cryptoKeys = {
        ENCRYPTION_DATA_IN_TRANSIT_PUBLIC_KEY: 'MFwwDQYJKoZIhvcNAQEBBQADSwAwSAJBAI6LRZ+msdiGpNk/35yqDv3pv2w9/AOHNjwCG8oyHNHmKej10tXojLEwR94dyoWGNSlKv8LIF8Y5KyVfprcoXKUCAwEAAQ==',
    };
} else if (environment === Environment.LOCALHOST) {
    cryptoKeys = {
        ENCRYPTION_DATA_IN_TRANSIT_PUBLIC_KEY: 'MFwwDQYJKoZIhvcNAQEBBQADSwAwSAJBAI6LRZ+msdiGpNk/35yqDv3pv2w9/AOHNjwCG8oyHNHmKej10tXojLEwR94dyoWGNSlKv8LIF8Y5KyVfprcoXKUCAwEAAQ==',
    };
} else {
    throw new Error(`Can’t configure CryptoConfig, Unknown environment=∞${environment}`);
}

export { cryptoKeys };
